import React from 'react';

const OurMission: React.FC = () => {
  return (
    <section className="bg-white py-16">
      <div className="layout-container max-w-[1360px] mx-auto px-5">
        <div className="flex flex-col items-start gap-5">
          <div className="px-3 py-1 rounded-full border border-[#B8B8B8] inline-flex items-center justify-center">
            <span className="text-[#919191] text-[10px] font-description font-normal">Our Purpose</span>
          </div>

          <div className="flex flex-col lg:flex-row justify-between items-start gap-8 lg:gap-12 w-full">
            <h2 className="flex-1 font-title text-[28px] md:text-[36px] font-medium leading-[1.15] max-w-[620px]">
              <span className="text-[#212121]">We support businesses in designing and optimising scalable tech </span>
              <span className="text-[#919191]">solutions based on their needs.</span>
            </h2>

            <p className="flex-[0.8] max-w-[480px] font-description text-[13px] md:text-[14px] font-light leading-[1.55] text-[#919191]">
              Our mission is to support B2B organizations in transforming their ideas into concrete, effective digital solutions that meet their business challenges.
              <br /><br />
              We help our partners to structure, secure, and manage their technology projects methodically, by designing bespoke tools that enhance operational efficiency and support growth.
              <br /><br />
              From strategic thinking to technical implementation, we engage at every stage of the project with a pragmatic, collaborative approach focused on sustainable results.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurMission;
